import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-delete-account-advisary',
  templateUrl: './mobile-delete-account-advisary.component.html',
  styleUrls: ['./mobile-delete-account-advisary.component.css']
})
export class MobileDeleteAccountAdvisaryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
